import {
  GET_USER_SESSION_ERROR,
  GET_USER_SESSION_SUCCESS,
} from "../actionNames";

export const initialState = {
  user: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_SESSION_SUCCESS: {
      return { ...state, user: action.user };
    }
    case GET_USER_SESSION_ERROR: {
      return { ...state, user: {} };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
